import { faker } from '@faker-js/faker';
import { cleanup, render } from '@testing-library/react';
import { HttpResponse, http } from 'msw';
import { setupServer } from 'msw/node';
import React from 'react';
import { Provider } from 'react-redux';

import constants from './constants';
import redux from './redux';
import translations from './translations';
import Views from './views';

translations.init();

function TestComponent() {
  return (
    <Provider store={redux.store}>
      <Views.GroupSwitcher />
    </Provider>
  );
}

describe('customer group selector loading failure', () => {
  // create a mock server
  const server = setupServer(
    http.get(constants.endpoints.get.hierarchySummary, () => {
      return HttpResponse.json({ status: 500 }, { status: 500 });
    }),
    http.get(constants.endpoints.get.context, () => {
      return HttpResponse.json({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
        enforce: 'customer_group',
        partner_uuid: faker.string.uuid(),
      });
    }),
  );

  beforeAll(() => {
    server.listen();
  });

  afterAll(() => {
    server.close();
  });

  afterEach(() => {
    server.resetHandlers();
    cleanup();
  });

  it('should render the group switcher button with an error text', async () => {
    redux.store.dispatch(redux.api.getData());

    render(<TestComponent />);

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });

    expect(redux.store.getState().api.isError).toStrictEqual(true);
  });
});
